import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [
   {
    path:'',
    loadChildren:()=>import('./auth/auth.module').then(m=>m.AuthModule)
  },
  { 
    path: 'client',
    loadChildren: () => import('./client/client.module').then(m => m.ClientModule)
  },
  // {path:'mail-preview/:id/:id1' , component:MailPreviewComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
